import script from "./time-range-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./time-range-select.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__